import React, { useState } from "react";
import { Plus, Ticket, X } from "lucide-react";
import { toast } from "sonner";
import { db } from "@/api/base44Client";
import { PROFESSIONS } from "@/lib/subjects";

export function CreateCodePanel({ onCreated, onClose }) {
  const [form, setForm] = useState({ code: "", note: "", profession: "", max_uses: 0 });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const create = async () => {
    setBusy(true);
    try {
      const lic = await db.admin.createLicense({ code: form.code || null, note: form.note, subject: form.profession || null, max_uses: Number(form.max_uses) || 0 });
      toast.success(`Code ${lic.code} erstellt`);
      setForm({ code: "", note: "", profession: "", max_uses: 0 });
      onCreated();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Code konnte nicht erstellt werden");
    } finally { setBusy(false); }
  };

  return (
    <div className="adm-subpanel" data-testid="admin-create-code-panel">
      <div className="adm-card-head">
        <h2 className="adm-card-title"><span className="adm-card-icon"><Ticket className="h-4 w-4" /></span>Neuen Code erstellen</h2>
        <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={onClose} aria-label="Schliessen" data-testid="admin-create-code-close"><X className="h-4 w-4" /></button>
      </div>
      <div className="adm-grid adm-grid-4">
        <label className="adm-field"><span className="adm-label">Code (leer = automatisch)</span>
          <input className="adm-input adm-code" data-testid="admin-code-input" value={form.code} onChange={(e) => set("code", e.target.value.toUpperCase())} placeholder="LAP-XXXX" /></label>
        <label className="adm-field"><span className="adm-label">Notiz (optional)</span>
          <input className="adm-input" data-testid="admin-code-note-input" value={form.note} onChange={(e) => set("note", e.target.value)} /></label>
        <label className="adm-field"><span className="adm-label">Beruf</span>
          <select className="adm-input" data-testid="admin-code-profession-select" value={form.profession} onChange={(e) => set("profession", e.target.value)}>
            <option value="">Alle Berufe</option>
            {PROFESSIONS.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select></label>
        <label className="adm-field"><span className="adm-label">Max. Nutzungen (0 = ∞)</span>
          <input type="number" min="0" className="adm-input" data-testid="admin-code-maxuses-input" value={form.max_uses} onChange={(e) => set("max_uses", e.target.value)} /></label>
      </div>
      <button className="adm-btn adm-btn-block" disabled={busy} onClick={create} data-testid="admin-code-submit"><Plus className="h-4 w-4" /> {busy ? "Wird erstellt…" : "Code erstellen"}</button>
    </div>
  );
}
